<template>
  <div class="report-page stock-report-page">
    <div class="report-hero">
      <div>
        <span class="report-eyebrow">Inventory Report</span>
        <h2>Stock Movement</h2>
        <p>
          Pantau mutasi stok berdasarkan produk, tanggal, dan tipe transaksi dalam satu tampilan pivot.
        </p>
      </div>
      <div class="report-actions">
        <b-button
          variant="light"
          class="report-switch-btn active"
          :to="{ name: 'stock' }"
        >
          Stock
        </b-button>
        <b-button
          variant="outline-light"
          class="report-switch-btn"
          :to="{ name: 'transaction-report' }"
        >
          Transaction
        </b-button>
      </div>
    </div>

    <b-card no-body class="report-card">
      <div class="report-card-header">
        <div>
          <h5>Stock Pivot</h5>
          <span>Gunakan field chooser untuk mengubah susunan laporan.</span>
        </div>
        <b-badge variant="light-warning" class="report-badge">
          Export Ready
        </b-badge>
      </div>

      <div class="report-grid-wrap">
        <DxPivotGrid
          id="stock"
          :allow-sorting-by-summary="true"
          :allow-sorting="true"
          :allow-filtering="true"
          :allow-expand-all="true"
          :height="620"
          :show-borders="false"
          :data-source="dataSource"
        >
          <DxHeaderFilter :show-relevant-values="true" :width="320" :height="420" />
          <DxFieldChooser :allow-search="true" />
          <DxFieldPanel :visible="true" />
          <DxExport :enabled="true" />
        </DxPivotGrid>
      </div>
    </b-card>
  </div>
</template>
<script>
import { BBadge, BButton, BCard } from 'bootstrap-vue'
import {
  DxPivotGrid,
  DxHeaderFilter,
  // DxSearch,
  DxFieldChooser,
  DxFieldPanel,
  DxExport,
} from 'devextreme-vue/pivot-grid'
import config from '@/config/config'
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source'
import { createStore } from 'devextreme-aspnet-data-nojquery'

export default {
  components: {
    BBadge,
    BButton,
    BCard,
    DxPivotGrid,
    DxHeaderFilter,
    DxFieldChooser,
    DxFieldPanel,
    DxExport,
  },
  data() {
    return {
      dataSource: new PivotGridDataSource({
        remoteOperations: true,
        store: createStore({
          key: 'kd_produk',
          loadUrl: `${config.apiUrl}/api/auth/report/stock`,
          onBeforeSend: (method, ajaxOptions) => {
            ajaxOptions.headers = {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            }
          },
        }),
        fields: [
          {
            caption: 'Product',
            dataField: 'kd_produk',
            area: 'row',
            sortBySummaryField: 'stock',
            sortBySummaryPath: [],
            sortOrder: 'asc',
            width: 250,
            // expanded: true,
          },
          {
            caption: 'Date',
            dataField: 'created_at',
            area: 'row',
            dataType: 'date',
            format: 'YYYY-MM-dd',
            groupName: 'date',
          },
          {
            groupName: 'date',
            groupInterval: 'year',
            // expanded: true,
          },
          {
            groupName: 'date',
            groupInterval: 'quarter',
            // expanded: true,
          },
          {
            groupName: 'date',
            groupInterval: 'month',
            // expanded: true,
          },
          {
            groupName: 'date',
            groupInterval: 'day',
            // expanded: true,
          },
          {
            caption: 'Type',
            dataField: 'type',
            dataType: 'string',
            area: 'column',
          },
          {
            caption: 'Quantity',
            dataField: 'quantity',
            summaryType: 'sum',
            area: 'data',
            dataType: 'number',
            customizeText: cellInfo =>
              cellInfo.value
                ? cellInfo.value < 0
                  ? `(${Math.abs(cellInfo.value)})`
                  : cellInfo.value.toString()
                : '0',
          },
        ],
      }),
    }
  },
}
</script>

<style lang="scss" scoped>
.report-page {
  --report-accent: #ffa000;
  --report-ink: #1f2733;
  --report-muted: #6e7786;
  --report-line: #eceff3;

  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.report-hero {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.5rem;
  padding: 2rem;
  border-radius: 18px;
  color: #fff;
  background:
    linear-gradient(135deg, rgba(18, 22, 30, 0.96), rgba(36, 36, 36, 0.9)),
    radial-gradient(circle at top right, rgba(255, 160, 0, 0.46), transparent 36%);
  box-shadow: 0 18px 48px rgba(26, 31, 40, 0.16);
}

.report-eyebrow {
  display: inline-flex;
  margin-bottom: 0.75rem;
  padding: 0.38rem 0.75rem;
  border: 1px solid rgba(255, 160, 0, 0.38);
  border-radius: 999px;
  color: #ffb82e;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.report-hero h2 {
  margin: 0;
  font-size: 2rem;
  font-weight: 800;
  letter-spacing: -0.03em;
}

.report-hero p {
  max-width: 620px;
  margin: 0.5rem 0 0;
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.98rem;
  line-height: 1.6;
}

.report-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.report-switch-btn {
  min-width: 118px;
  border-radius: 999px;
  font-weight: 700;
}

.report-switch-btn.active {
  color: #161616;
  background: var(--report-accent);
  border-color: var(--report-accent);
}

.report-card {
  overflow: hidden;
  border: 1px solid var(--report-line);
  border-radius: 18px;
  box-shadow: 0 14px 38px rgba(31, 39, 51, 0.07);
}

.report-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--report-line);
  background: linear-gradient(180deg, #fff, #fbfcfe);
}

.report-card-header h5 {
  margin: 0;
  color: var(--report-ink);
  font-weight: 800;
}

.report-card-header span {
  color: var(--report-muted);
  font-size: 0.9rem;
}

.report-badge {
  border-radius: 999px;
  padding: 0.45rem 0.8rem;
  color: #8b5b00;
  font-weight: 800;
}

.report-grid-wrap {
  padding: 1rem;
  background: #fff;
}

::v-deep .dx-pivotgrid {
  border: 0;
  color: var(--report-ink);
  font-family: inherit;
}

::v-deep .dx-pivotgrid .dx-area-description-cell,
::v-deep .dx-pivotgrid .dx-column-header,
::v-deep .dx-pivotgrid .dx-row-header {
  background: #f8fafc;
  color: #49505c;
  font-weight: 700;
}

::v-deep .dx-pivotgrid .dx-data-header,
::v-deep .dx-pivotgrid .dx-grandtotal {
  background: #fff8e6;
  color: #1f2733;
  font-weight: 800;
}

::v-deep .dx-pivotgrid .dx-pivotgrid-border .dx-filter-header {
  border-color: var(--report-line);
}

::v-deep .dx-pivotgrid td {
  border-color: var(--report-line);
}

@media (max-width: 767px) {
  .report-hero,
  .report-card-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .report-hero {
    padding: 1.5rem;
  }

  .report-hero h2 {
    font-size: 1.6rem;
  }
}
</style>
